import { createApi } from '@reduxjs/toolkit/query/react'
import { ITerminology, ITerminologyResponse } from 'shared/models/Terminology'
import axiosBaseQuery from 'shared/utils/axiosBaseQuery'

const terminologyApi = createApi({
  reducerPath: 'terminology',
  baseQuery: axiosBaseQuery({ baseUrl: '/mergefield/terminology' }),
  endpoints: (build) => ({
    getTerminology: build.query<ITerminology, string>({
      query: (clientId) => ({ url: `?clientId=${clientId}`, method: 'GET' }),
      transformResponse: ({ terminology }: ITerminologyResponse) => terminology,
    }),
  }),
})

export default terminologyApi
